<template>
  <v-timeline :dense="$vuetify.breakpoint.smAndDown">
    <v-timeline-item 
    color="primary" 
    fill-dot
    v-for="item in items"
    :key="item.title"
    >
      <v-card>
        <v-card-title class="primary"></v-card-title>
        <v-container>
          <v-row class="mx-1">
            <!-- ねん -->
            <p class="primary--text my-3">{{ item.date }}</p>
          </v-row>
          <v-row class="mx-1">
            <!-- タイトル -->
            <p class="text-subtitle-1 text-sm-h5">
              {{ item.title }}
            </p>
            <!-- 本文 -->
          </v-row>
          <v-row class="mx-1">
            <p class="text-body-2 text-sm-subtitle-2">
              {{ item.detail }}
            </p>
          </v-row>
        </v-container>
      </v-card>
    </v-timeline-item>
    
  </v-timeline>
</template>
<script>
export default {
  data: () => ({
    items: [
      {
        date:"2017年 4月",
        title:"法政大学 情報科学部\nコンピュータ科学科 入学",
        detail:"漠然とエンジニアになりたいと思っており、\n情報科学部に入学しました。\n入学時には特待生などの権利を得ることができました。"
      },
      {
        date:"2019年 8月",
        title:"NTT東日本5days\nインターンシップ参加",
        detail:"与えられたペルソナにソリューションの提供、実現経費などをプレゼンし、\nコンペ形式で受注してもらえるかを競う内容でした。\n上流工程の設計方法、グループでの進め方だけでなく、\n周りの院生の方々の発表スキルを習得しました。"
      },
      {
        date:"2021年 3月",
        title:"法政大学 卒業",
        detail:"大学の4年間でプログラミング、PCの部品の役割、\nネットワークをきっちり学びました。\n卒業研究ではPythonのライブラリnumpy,Pandas,matplotlib,seabornを\n組み合わせた数学の可視化フレームワークを作成しました。\n高校～大学の授業で取り扱う問題毎に可視化させるのを目的に作成しました。"
      },
      {
        date:"2021年 4月",
        title:"都内上場企業入社",
        detail:"大学ではプログラミングを学んでいたので\nエンジニアで就活を考えていましたが\n将来転職や独立する際にマーケティングスキルが必ず\n活きると考えマーケティング企業に就職しました。"
      },
      {
        date:"2021年 9月",
        title:"webマーケティング資格取得",
        detail:"webマーケティングを学び、googleが発行するウェブマーケティングの資格を取得しました。\nここでSNS運用の方法などを学び、twitterの自動化プログラムと掛け合わせてソースコードを書くなど幅が広がりました。"
      },
      {
        date:"2021年 12月",
        title:"副業収入5万円達成",
        detail:"大学生時代に培ったプログラミングの技術とwebマーケティングで学んだSEOなどを掛け合わせてwebライターの副業を開始しました。"
      },
      {
        date:"2022年 1月",
        title:"Lancers 認定ランサーに昇格",
        detail:"プログラミングを活かした副業で認定ランサーになることができました。\n主にVueの手伝いやPythoの自動化、スクレイピングの案件をこなしました。"
      },
      {
        date:"Coming Soon",
        title:"大手プログラミングスクールAIコースメンター開始",
        detail:"AI学習のメンターとなり新たに挑戦する人々のサポートを行っていきます。"
      },
      // {
      //   date:"",
      //   title:"",
      //   detail:""
      // },
    ]
  })
}
</script>